import moment from "moment-timezone";
import React from "react";
import {reverseEnum} from "../components/Utility";
import {PaymentStatus} from "../enums/enums";

const timezone = 'Asia/Kolkata';

export const getTableColumns = ({ActionDropdown, deleteHandler, markAsPaidHandler}) => {
    let tableColumns = [
        {header: "To", field: "customer"},
        {header: "Invoice No", field: "invoice"},
        {header: "Grand Total", field: "total"},
        {header: "Advance Paid", field: "advancePaid"},
        {header: "Amount Due", field: "remaining"},
        {header: "Created At", field: "createDate"},
        {header: "Start Date", field: "startDate"},
        {header: "End Date", field: "endDate"},
        {header: "Status", field: "status"},
    ];

    tableColumns.push({
        header: "Action",
        disableSorting: true,
        field: "action",
        align: "right",
        render: (row) => <ActionDropdown row={row} onDelete={deleteHandler} view={true} edit={true}
                                         onMarkAsPaid={markAsPaidHandler}/>,
    });

    return tableColumns;
};

export const getTableData = ({items = []}) => {
    if (!Array.isArray(items)) return [];
    return items.map((item) => ({
        id: item.id,
        invoice: item.invoiceNo,
        customer: <div className="text-truncate">{item.customer?.name ? item.customer.name : 'Guest'}</div>,
        advancePaid: item.totals?.advancePaid,
        total: item.totals?.total,
        remaining:
            (Number(item.totals?.subtotal) || 0) -
            ((Number(item.totals?.discount) || 0) + (Number(item.totals?.advancePaid) || 0)),
        createDate: item.createdAt ? moment(item.createdAt).tz(timezone).format('MMM DD, YYYY') : "-",
        startDate: item.startDate ? moment(item.startDate).tz(timezone).format('MMM DD, YYYY') : "-",
        endDate: item.endDate ? moment(item.endDate).tz(timezone).format('MMM DD, YYYY') : "-",
        status: item.status != null ? reverseEnum(PaymentStatus)[item.status] : "-",
        Status: item.status
    }));
};